<template>
  <div class="main-container" id="main-container" style="display: none;">
    <Nav @logout="logout"  @userCenter="userCenter" :info="info" v-if="!from || from == 0"/>
    <div v-show="!showUserCenter" :class="!from || from == 0 ? 'resource-index-div': 'resource-index-div-1'">
      <router-view :user-info="info.userInfo" :from="from"><ResourceIndex/></router-view>
    </div>
    <div style="height:calc(100vh - 60px)" v-show="showUserCenter">
      <PwdUpdate @back="showUserCenter=false"></PwdUpdate>
    </div>
    <pack-download ref="packDownload"></pack-download>
  </div>
</template>

<script>
import Nav from '../../../common-components/src/components/Nav/ResourceNav.vue'
import ResourceIndex from "@/views/ResourceIndex";
import PwdUpdate from "@/views/user-center/PwdUpdate";
import PackDownload from "@/components/pack-download.vue"

export default {
  components: {
    Nav,
    ResourceIndex,
    PwdUpdate,
    PackDownload
  },
  data() {
    return {
      from: "0",
      authorization: this.$route.query.authorization,
      info:{
        userInfo:{},
        resdownUrl:"",
        pcdownUrl:this.$root.resourceServer + "/pcdown/",
        qrUrl:this.$root.resourceServer+'/#/download-page',
        helpUrl:this.$root.uclassServer + "/help"
      },
      showUserCenter:false,
      stageTimer: null,
    };
  },
  created() {
    this.$root.$on('doPackReportFile', (url) => {
      this.doPackReportFile(url);
    });
  },
  beforeMount() {
    console.log("main beforeMount")
  },
  mounted() {
    //设置登录信息
    if(this.authorization && typeof this.authorization != 'undefined') {
      localStorage.setItem('rs_t', this.authorization);
    }
    // 设置系统参数
    this.initSystemPara();
    if (this.$route.path === "/main"){
      this.from = this.$route.query.from;
      if (this.from && this.from == 1){
        sessionStorage.setItem('fromPc', "1");
      }else {
        sessionStorage.setItem('fromPc', "0");
      }
    }else {
      this.from = sessionStorage.getItem('fromPc');
    }
    if (localStorage.getItem('resourceLoginUrl') != null){
      this.loginCheck();
    }
  },
  methods: {
    init(){
      console.log("this.$route.path", this.$route.path)
      if(this.authorization && typeof this.authorization != 'undefined' && this.from == 1){
        //授课端打开资源库，写入登录日志
        this.pcLoginLog();
      }
      document.getElementById("main-container").style.display = "block";
      this.getUserInfo();
      //跳转至默认主页
      if (this.$route.path == '/main') {
        this.$router.replace({path: '/main/resource-index/resource-content'});
      }
      //定时器
      if(this.stageTimer != null){
        clearInterval(this.stageTimer)
      }
      this.stageTimer = setInterval(() => {
        this.getUserStage();//
      }, 10000)
      //销毁定时器
      this.$once('hook:beforeDestroy', () => {
        clearInterval(this.stageTimer)
      })
    },
    initSystemPara(){
      this.ucloading.showLoading();
      this.$api.get("/resapi/system/getSystemPara").then(res => {
        this.ucloading.hideLoading();
        if (res.success && res.data){
          if(res.data.resourceServer){
            this.$root.resourceServer = res.data.resourceServer;
          }
          if(res.data.uclassServer){
            this.$root.uclassServer = res.data.uclassServer;
          }
          if(res.data.recycleValidTime){
            this.$root.recycleValidTime = res.data.recycleValidTime;
          }
          this.info.pcdownUrl = this.$root.resourceServer + "/pcdown/";
          this.info.qrUrl = this.$root.resourceServer + "/#/download-page";
          this.info.helpUrl = this.$root.uclassServer + "/help";
          //设置登录页地址
          localStorage.setItem("resourceLoginUrl", this.$root.uclassServer + "/teacher/login?redirectTo=" + this.$root.resourceServer + "/resapi/tw/login/callback");
          //未登录，则直接跳转到登录页
          if(!localStorage.getItem('rs_t')){
            window.location.replace(localStorage.getItem('resourceLoginUrl'));
            return;
          }
          this.loginCheck();
        } else {
          this.$message.error(res.info || "查询失败");
        }
      }).catch(res => {
        this.ucloading.hideLoading();
        console.log(res);
      });
    },
    pcLoginLog(){
      this.$api.post("/resapi/pc/user/loginLog").then(() => {

      }).catch(res => {
        console.error(res);
      });
    },
    loginCheck(){
      this.$api.post("/resapi/tw/user/loginCheck").then(res => {
        if (res.success){
          this.init();
        }
      }).catch(res => {
        console.log(res);
        this.init();
      });
    },
    getUserInfo(){
      this.$api.get("/resapi/tw/user/getUserBaseInfo").then(res => {
        if (res.success && res.data){
          localStorage.setItem('userId-authorization',  res.data.userId)
          this.info.userInfo = res.data;
        } else {
          console.error(res.info || "获取用户信息失败");
        }
      }).catch(res => {
        console.log(res);
      });
      window.navUserInfo = this.info;
      this.$store.commit('setNavInfo',this.info)
    },
    getUserStage(){
      if(this.info.userInfo){
        let loginError = sessionStorage.getItem("loginError");
        if(loginError && loginError == 1){
          return;
        }
        this.$api.get("/resapi/tw/user-storage/queryStorage").then(res => {
          if (res.success && res.data){
            this.$set(this.info.userInfo, "maxStorage", res.data.maxStorage);
            this.$set(this.info.userInfo, "usedStorage", res.data.usedStorage);
            this.$set(this.info.userInfo, "freeStorage", res.data.freeStorage);
          } else {
            console.log(res.info || "获取用户信息失败");
          }
        }).catch(res => {
          console.log(res);
        });
      }
    },
    userCenter(){
        if(this.showUserCenter){
          this.showUserCenter=false;
        }else{
          this.showUserCenter=true
        }
    },
    logout(){
      let vm = this;
      vm.ucloading.showLoading();
      vm.$api.post("/resapi/tw/login/logout").then(res => {
        if (!res.success) {
          return vm.$message.error(res.info);
        }
        localStorage.removeItem('rs_t');
        window.location.replace(localStorage.getItem('resourceLoginUrl'));
      }).catch(res => {
        console.error(res);
      });
    },
    doPackReportFile(url) {
      this.$refs.packDownload.doPackReportFile(url);
    },
  }
}
</script>

<style lang="scss" scoped>
.main-container{
  height: 100%;

  .resource-index-div{
    height: calc(100% - 44px);
  }

  .resource-index-div-1{
    height: 100%;
  }
}
</style>